const begiver = {
  FORMS: [
    {
      type: 'begiver-contact-form',
      name: 'BegiverContactForm',
      message: {
        open: 'Formulario Contacto',
        send: 'Envío Formulario De Contacto'
      }
    }
  ],
  CSS: {
    id: '628cf209ccdb7d1e3445b060',
    name: 'begiver',
    avatar: {
      name: 'Sofía',
      header: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/9AdaDq1jUo7r1654726059554.png',
      new: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/yc94y7UqKNI21654726036338.png',
      open: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/VY4C5zMkQPnG1654726086187.png',
      close: 'https://gatblac.nyc3.digitaloceanspaces.com/PROD/profiles/9AdaDq1jUo7r1654726059554.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#F4D80C',
        borderColor: '#F4D80C'
      }
    }
  }
}

export default begiver
